import services from 'api/services';
import { logError } from 'global/errors';

import { GET_XPS_REQUEST, GET_XPS_SUCCESS, GET_XPS_FAILURE } from './constants';

const { XPService } = services;

export const getXPs = (accountId) => async (dispatch) => {
  try {
    dispatch({ type: GET_XPS_REQUEST });
    const data = await XPService.getXPs(accountId);
    dispatch({ type: GET_XPS_SUCCESS, XPs: data });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_XPS_FAILURE, error: ex.message });
  }
};
